// Replace the phone number with your actual WhatsApp number (country code, no + or spaces)
export const WHATSAPP_NUMBER = "918830149701";

// In production (Amplify), set REACT_APP_API_URL to the Elastic Beanstalk URL,
// e.g. http://krivaexim-env.eba-4dgjvrxn.ap-south-1.elasticbeanstalk.com
// Locally, fall back to the CRA dev proxy ("/api").
export const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL.replace(/\/+$/, "")}/api`
  : "/api";
